package com.patronat.top.features.usermanagement.domain.usecase

import com.patronat.top.core.dispatchers.DispatcherProvider
import com.patronat.top.core.domain.models.DomainResult
import com.patronat.top.core.domain.models.profiles.User
import com.patronat.top.domain.usecase.BaseUseCase
import com.patronat.top.features.usermanagement.domain.repository.ProfileRepository

data class UpdateUserCommand(val user: User)

class UpdateUserUseCase(
    private val profileRepository: ProfileRepository,
    dispatcherProvider: DispatcherProvider
) : BaseUseCase<UpdateUserCommand, DomainResult<Unit>>(dispatcherProvider.io) {
    override suspend fun doWork(command: UpdateUserCommand): DomainResult<Unit> {
        return profileRepository.updateUser(command.user)
    }
}